import { API_AUTH, setTokenGlobal } from "./common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
    token = token.substring(6);
    setTokenGlobal(token, urlNew);
}
export default {

    getAllConfigSTKey: (params) =>
        API_AUTH.get("danhmuc/getAllConfigSTKey", params),

    getDanhMucStore: (params) => API_AUTH.get("danhmuc/getDanhMucStore", params),
    getDanhMucCategory: (params) =>
        API_AUTH.get("danhmuc/getDanhMucCategory", params),
    getDanhMucCategory1: (params) =>
        API_AUTH.get("danhmuc/getDanhMucCategory1", params),
    getDanhMucCategoryBaoGia: (params) =>
        API_AUTH.get("danhmuc/getDanhMucCategoryBaoGia", params),
    getDanhMucGroupCus: (params) =>
        API_AUTH.get("danhmuc/getDanhMucGroupCus", params),

    getDanhMucBank: (params) => API_AUTH.get("danhmuc/getDanhMucBank", params),
    getDanhMucBankNoTienMat: (params) => API_AUTH.get("danhmuc/getDanhMucBankNoTienMat", params),
    getConfigByKey: (params) => API_AUTH.get("danhmuc/getConfigByKey", params),

    getThongTinFormIn: (params) =>
        API_AUTH.get("danhmuc/getThongTinFormIn?iBranch=" + params),
    getGiaSanPhamTheoSoLuong: (params) =>
        API_AUTH.get(
            "danhmuc/GetGiaSanPhamTheoSoLuong?CategoryId=" +
            params.CategoryId +
            "&SoLuong=" +
            params.SoLuong
        ),
};
